// @ts-nocheck
import { Injectable, inject } from '@angular/core';
import moment from 'moment';
import { Logger } from './logger.service';
import { INote } from './note.interface';
import { NoteService } from './note.service';

@Injectable({
	providedIn: 'root',
})
export class CommentForumService {
	private logger = inject(Logger);
	private noteService = inject(NoteService);


	loadContent(entityKey: string, data: any) {
		try {
			return data[entityKey];
		} catch (error) {
			this.logger.error(error);
			throw error;
		}
	}

	typeLoad(config: any) {
		if (config?.fromHistoric) {
			return 'fromHistoric';
		}

		if (config?.fromObservationInternal) {
			return 'fromObservationInternal';
		}

		if (config?.byTaskId) {
			return 'byTaskId';
		}

		if (config?.fromContext) {
			return 'fromContext';
		}

		return 'default';
	}

	loadMessages(typeLoad: any, processId?: string, context?: string, taskId?: string) {

		switch (typeLoad) {
			case 'fromHistoric':
				return this.fromHistoric(processId??'', context??'');
			case 'fromObservationInternal':
				return this.fromObservationInternal(processId??'', 'observationInternal');
			case 'byTaskId':
				return this.fromProcess(processId??'', context??'');
			case 'fromContext':
				return this.fromContext(context??'');
			default:
				return this.byTaskId(taskId??'');
		}
	}

	filterMessagesByTypeLoad(typeLoad: string, notes: INote[], entityKey?: string): any {
		switch (typeLoad) {
			case 'fromHistoric':
				return this.filterMessagesFromHistoric(notes, entityKey);
			default:
				return this.filterMessagesDefault(notes);
		}
	}

	filterMessagesDefault(notes: INote[]) {
		return notes.map((note: INote) => {
			note.data = moment((note.createAt || 0) * 1000).format('LLLL');
			return note;
		});
	}

	filterMessagesFromHistoric(notes: INote[], entityKey?: string) {
		const fromHistoricMapper = [
			['userFullname', 'divergenceUserFullName'],
			['createAt', 'createAt'],
			['content', 'divergence'],
		];

		return notes.map((note: INote) => {
			let commentForumObject: any = note;

			if (commentForumObject.file) {
				commentForumObject.fileConfig = {
					disable: true,
					entityKey: entityKey,
					contextKey: 'file',
					label: 'Anexo',
					optionClientView: 'true',
					maxFiles: '1',
					changeFileButtonDisabled: true,
					readonly: true,
				};
			}

			commentForumObject = fromHistoricMapper.reduce(
				(obj, [key, value]) => ({ ...obj, [key]: commentForumObject[value] }),
				{},
			);

			return {
				...commentForumObject,
				fileConfig: commentForumObject?.fileConfig,
				data: moment(commentForumObject?.createAt * 1000).format('LL'),
			};
		});
	}

	fromObservationInternal(processId: string, context: string) {
		return this.noteService.getNotes({ processId, context }, 'getNotesByProcessId');
	}

	fromHistoric(processId: string, context: string) {
		return this.noteService.getNotes({ processId, context }, 'getHistoricCourtHearing');
	}

	byTaskId(taskId: string) {
		return this.noteService.getNotes({ taskId }, 'getNotesByTaskId');
	}

	fromContext(context: string) {
		return this.noteService.getNotes({ context }, 'getNotesByContext');
	}

	fromProcess(processId: string, context: string) {
		return this.noteService.getNotes({ processId, context }, 'getNotesByProcessId');
	}

	sendNotes(body) {
		try {
			return this.noteService.sendNotes(body);
		} catch (error) {
			this.logger.error(error);
			throw error;
		}
	}

	upNotes(body, id) {
		try {
			return this.noteService.upNotes(body, id);
		} catch (error) {
			this.logger.error(error);
			throw error;
		}
	}
}
